export default __webpack_public_path__ + "static/media/variluxG9-bg-2.56bf9d73.webp";